/*
 * @Author: lc
 * @Date: 2022-06-08 10:06:46
 * @LastEditors: lc
 * @LastEditTime: 2022-06-08 10:07:57
 * @Description: 
 */
/**
 * 专题评论 接口的统一出口
 */
import axios from "../http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = "/c-api/";

const zhuanticomment = {
    // 列表
    list (params) {
        return axios.get(api + "zhuanticomment/list", { params: params });
    },
    // 删除
    remove (params) {
        return axios.post(api + "zhuanticomment/remove", qs.stringify(params));
    },
    // 更新状态
    status (params) {
        return axios.post(api + "zhuanticomment/status", qs.stringify(params));
    },
};

// 导出接口
export default zhuanticomment;

